import { useEffect } from 'react';
import { ProductCodeKey } from '@dayetopia/library';
import { useAccountStore } from '@components/dashboard/context/UserDashboardContext';
import { AppState, MainContextActionTypes } from '@constants';
import { CartItemGiftType, PromotionObject } from '@contracts';
import { getFromLocalStorage } from '@utils/localStorage';

// Prescription fees that are not associated with a medication fee are removed
function removeOrphanedPrescriptionFees(cartItems: AppState['cartItems'], dispatch: React.Dispatch<MainContextActionTypes>) {
  const orphanedPrescriptionFees = cartItems.filter(
    (item) =>
      (item.productCode === ProductCodeKey.VMSPrescriptionFee || item.productCode === ProductCodeKey.STIPrescriptionFee) &&
      !cartItems.some(
        (parent) => parent.productCode === ProductCodeKey.VMSMedicationFee && parent.dependantCartItems?.some((dep) => dep.id === item.id)
      )
  );

  orphanedPrescriptionFees.forEach((orphanedFee) => {
    dispatch({ type: 'cartItemRemove', data: orphanedFee });
  });
}

function useCheckCartItems(state: AppState, dispatch: React.Dispatch<MainContextActionTypes>) {
  const purchases = useAccountStore((accountState) => accountState.purchases);

  useEffect(() => {
    const promotions: PromotionObject[] = getFromLocalStorage('promotions', true) ?? [];
    if (!Array.isArray(promotions)) return;

    promotions.forEach((promo) => {
      const currentDate = new Date();
      const startDate = new Date(promo.startDate);
      const endDate = new Date(promo.endDate);
      const isPromoActive = currentDate >= startDate && currentDate <= endDate;

      const freeGift = state.cartItems.find((item) => item.id === `${promo.freeGift}_free` && item.giftType === CartItemGiftType.Promotion);
      if (freeGift && !isPromoActive) {
        dispatch({ type: 'cartItemRemove', data: freeGift });
      }
    });

    removeOrphanedPrescriptionFees(state.cartItems, dispatch);

    const tamponSubscription = purchases.subscriptions?.find((subscription) => subscription.planCode?.includes('tampon'));
    const tamponBoxCartItem = state.cartItems.find((item) => item.productCode === `${ProductCodeKey.TamponBox}` && item.dependantCartItems);
    if (tamponSubscription && tamponBoxCartItem) {
      tamponBoxCartItem.dependantCartItems?.forEach((cartItem) => {
        dispatch({ type: 'cartItemRemove', data: cartItem });
      });
      dispatch({ type: 'cartItemDependantItemsRemove', data: tamponBoxCartItem });
    }
  }, [state.cartItems, purchases]);
}

export default useCheckCartItems;
